// extracted by mini-css-extract-plugin
export var sectionContainer = "valuesTabs-module--sectionContainer--6+hiU";
export var scrollContainer = "valuesTabs-module--scrollContainer--Eo5vg";
export var sectionTitle = "valuesTabs-module--sectionTitle--cIk51";
export var sectionContent = "valuesTabs-module--sectionContent--e0-nN";
export var item = "valuesTabs-module--item--TQxDA";
export var slidesWrapper = "valuesTabs-module--slidesWrapper--Jl86O";
export var imageContainer = "valuesTabs-module--imageContainer--GLv7l";
export var textContainer = "valuesTabs-module--textContainer--7yMpY";
export var sectionItem = "valuesTabs-module--sectionItem--BYwLX";